// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet crm-internal API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { CollectionResultOfCrmAdviseursGetAdviseursDto } from '../model/collectionResultOfCrmAdviseursGetAdviseursDto';

import type { TussenpersonenGetParams } from '../model/tussenpersonenGetParams';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.AdviseurInzien</li></ul>
 * @summary Haal alle adviseurs op, standaard maatschappij-, systeem- en webgebruikeradviseurs uitgesloten
 */
export const tussenpersonenGet = (
  params?: MaybeRef<TussenpersonenGetParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<CollectionResultOfCrmAdviseursGetAdviseursDto>(
    { url: `/api/v1/tussenpersonen`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getTussenpersonenGetQueryKey = (params?: MaybeRef<TussenpersonenGetParams>) => {
  return ['api', 'v1', 'tussenpersonen', ...(params ? [params] : [])] as const;
};

export const getTussenpersonenGetQueryOptions = <
  TData = Awaited<ReturnType<typeof tussenpersonenGet>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<TussenpersonenGetParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tussenpersonenGet>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getTussenpersonenGetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tussenpersonenGet>>> = ({ signal }) =>
    tussenpersonenGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tussenpersonenGet>>,
    TError,
    TData
  >;
};

export type TussenpersonenGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof tussenpersonenGet>>
>;
export type TussenpersonenGetQueryError = ErrorType<void>;

/**
 * @summary Haal alle adviseurs op, standaard maatschappij-, systeem- en webgebruikeradviseurs uitgesloten
 */

export function useTussenpersonenGet<
  TData = Awaited<ReturnType<typeof tussenpersonenGet>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<TussenpersonenGetParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tussenpersonenGet>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTussenpersonenGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
